import { BaseControlOption } from '../control-options/control-option.interface';
import { CurrencySelect } from '../select-controls/currency-select.model';
import { NumericControl } from './numeric-control.model';

export class MoneyControl extends NumericControl {

  currencySelect: CurrencySelect;

  constructor(id: string, label: string, value: number | null, currencyCode: string | null, currencyCodeName: string | null, timestamp: Date | null, ...options: BaseControlOption[]) {
    super(id, label, value, 2, "n", options);

    this.className = "MoneyControl";

    if (currencyCode == null) {
      currencyCode = "USD";
    }

    if (currencyCodeName == null) {
      currencyCodeName = "US Dollar";
    }

    if (timestamp == null) {
      timestamp = new Date();
    }

    var selectedValue = { code: currencyCode, name: currencyCodeName };
    this.currencySelect = new CurrencySelect("currencyCode", "", selectedValue);
    this.currencySelect.timestamp = timestamp;
  }

  getMoneyValue(): number | null {
    return this.value;
  }
  getMoneyCurrency(): string | null {
    return this.currencySelect.getValue();
  }
}
